export default __webpack_public_path__ + "static/media/galeri7.fc78a9a2.jpg";